import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { providers, utils } from "ethers";
import MixinAPI from "@foxone/mixin-api";
import { MVMChain, NativeAssetId } from "./constants.js";
import { fmtWithdrawAmount, fmtBalance, wrapPromiseWithTimeout } from "./helper.js";
import { signAuthenticationToken } from "@foxone/mixin-api/encrypt";
import ContractOpt from "./contract.js";
import Cache from "./cache.js";
import bridge from "./bridge.js";
import connect from "./connect/index.js";
import EventEmitter from "events";
export default class MVM extends EventEmitter {
  constructor(config) {
    super();
    this.user = null;
    this.contractOpt = null;
    this.library = null;
    this.provider = null;
    this.account = "";
    this.connected = false;
    this.api = new MixinAPI();
    this.config = void 0;
    this.cache = void 0;
    this.config = config;
    this.cache = new Cache(this.api);
  }

  async connenct(type) {
    const provider = await connect(type, this.config);
    const library = new providers.Web3Provider(provider, "any");
    const accounts = await library.listAccounts();
    const network = await library.getNetwork();

    if (network.chainId !== Number(MVMChain.chainId)) {
      try {
        var _library$provider$req, _library$provider;

        await wrapPromiseWithTimeout((_library$provider$req = (_library$provider = library.provider).request) === null || _library$provider$req === void 0 ? void 0 : _library$provider$req.call(_library$provider, {
          method: "wallet_switchEthereumChain",
          params: [{
            chainId: MVMChain.chainId
          }]
        }));
      } catch (error) {
        var _error$message;

        if (error.code === 4902 || error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.includes("Unrecognized chain ID")) {
          var _library$provider2, _library$provider2$re;

          await wrapPromiseWithTimeout((_library$provider2 = library.provider) === null || _library$provider2 === void 0 ? void 0 : (_library$provider2$re = _library$provider2.request) === null || _library$provider2$re === void 0 ? void 0 : _library$provider2$re.call(_library$provider2, {
            method: "wallet_addEthereumChain",
            params: [MVMChain]
          }));
        }
      }
    }

    const account = accounts[0];
    const address = utils.getAddress(account);
    const user = await bridge.getProxyUser(address);
    this.library = library;
    this.provider = provider;
    this.account = address;
    this.user = user;
    this.contractOpt = new ContractOpt(library);
    this.connected = true;
    this.api.config(user.key);
    provider.on("accountsChanged", () => this.disconnect());
    provider.on("chainChanged", chain => {
      if (chain !== MVMChain.chainId) {
        this.disconnect();
      }
    });
    provider.on("disconnect", () => this.disconnect());
  }

  disconnect() {
    this.emit("disconnect");
    this.clear();
  }

  clear() {
    this.library = null;
    this.provider = null;
    this.account = "";
    this.contractOpt = null;
    this.user = null;
    this.connected = false;
  }

  getNetwork() {
    var _this$library;

    return (_this$library = this.library) === null || _this$library === void 0 ? void 0 : _this$library.getNetwork();
  }

  async watchAsset(params) {
    var _this$contractOpt, _this$library2, _this$library2$provid, _this$library2$provid2;

    const address = await ((_this$contractOpt = this.contractOpt) === null || _this$contractOpt === void 0 ? void 0 : _this$contractOpt.getContractAddressByAssetId(params.assetId));
    await ((_this$library2 = this.library) === null || _this$library2 === void 0 ? void 0 : (_this$library2$provid = (_this$library2$provid2 = _this$library2.provider).request) === null || _this$library2$provid === void 0 ? void 0 : _this$library2$provid.call(_this$library2$provid2, {
      method: "wallet_watchAsset",
      params: {
        options: {
          address,
          decimals: 8,
          image: params.image,
          symbol: params.symbol
        },
        type: "ERC20"
      }
    }));
  }

  async withdraw(payload) {
    const network = await this.getNetwork();

    if ((network === null || network === void 0 ? void 0 : network.chainId) !== Number(MVMChain.chainId)) {
      throw new Error("Current chain is not Mixin Virtual Machine");
    }

    const {
      action,
      amount,
      asset_id
    } = payload;
    const isNative = asset_id === NativeAssetId;
    const extra = await bridge.getExtra(action);
    const to = await bridge.getProxyUserContract(this.account);
    const value = fmtWithdrawAmount(String(amount), isNative);

    if (isNative) {
      var _this$contractOpt2;

      await ((_this$contractOpt2 = this.contractOpt) === null || _this$contractOpt2 === void 0 ? void 0 : _this$contractOpt2.execBridgeContract("release", [to, extra], value));
    } else {
      var _this$contractOpt3;

      await ((_this$contractOpt3 = this.contractOpt) === null || _this$contractOpt3 === void 0 ? void 0 : _this$contractOpt3.execAssetContract(asset_id, "transferWithExtra", [to, value, extra]));
    }
  }

  async getAsset(assetId) {
    var _await$this$library$g, _this$library3, _this$contractOpt4;

    const isNative = assetId === NativeAssetId;
    const resp = isNative ? ((_await$this$library$g = await ((_this$library3 = this.library) === null || _this$library3 === void 0 ? void 0 : _this$library3.getBalance(this.account))) !== null && _await$this$library$g !== void 0 ? _await$this$library$g : "0").toString() : await ((_this$contractOpt4 = this.contractOpt) === null || _this$contractOpt4 === void 0 ? void 0 : _this$contractOpt4.execAssetContract(assetId, "balanceOf", [this.account]));
    const balance = fmtBalance(resp, isNative);
    const asset = await this.cache.getAsset(assetId);
    return _objectSpread(_objectSpread({}, asset), {}, {
      balance
    });
  }

  async getAssets() {
    const tokens = await bridge.getTokenList(this.account);
    const assets = await Promise.all(tokens.map(async token => {
      var _this$contractOpt5;

      const assetId = await ((_this$contractOpt5 = this.contractOpt) === null || _this$contractOpt5 === void 0 ? void 0 : _this$contractOpt5.getAssetIdByContractAddress(token.contractAddress));
      if (!assetId) return null;
      const asset = await this.cache.getAsset(assetId);
      const balance = fmtBalance(token.balance);
      return _objectSpread(_objectSpread({}, asset), {}, {
        balance
      });
    }));
    const nativeAsset = await this.getAsset(NativeAssetId);
    return [nativeAsset, ...assets].filter(x => !!x);
  }

  getAuthToken() {
    return this.signToken({
      data: "",
      method: "GET",
      url: "/me"
    });
  }

  signToken({
    data,
    method,
    url
  }) {
    if (!this.user) {
      throw new Error("No proxy user found");
    }

    return signAuthenticationToken(this.user.key.client_id, this.user.key.session_id, this.user.key.private_key, method, url, data);
  }

}